import React from "react";
import PropTypes from "prop-types";

import "./HeroSection.css";

function HeroSection(props) {
  const {
    lightBg,
    topLine,
    lightText,
    lightTextDesc,
    headline,
    description,
    src,
    alt,
    imgStart,
    bottomPadding,
    topPadding,
    largeImage,
  } = props;

  const hero_section = bottomPadding
    ? topPadding
      ? "hero__section hero__section--bottom-padding hero__section--top-padding"
      : "hero__section hero__section--bottom-padding"
    : topPadding
    ? "hero__section hero__section--top-padding"
    : "hero__section";

  return (
    <>
      <div className={lightBg ? hero_section : hero_section + " hero--darkBg"}>
        <div className="hero__container">
          <div
            className="hero__row"
            style={{
              display: "flex",
              flexDirection: imgStart == "start" ? "row-reverse" : "row",
            }}
          >
            <div className="hero__col">
              <div className="hero__text-wrapper">
                <div
                  className={
                    lightBg
                      ? "hero__top-line"
                      : "hero__top-line hero__top-line--dark"
                  }
                >
                  {topLine}
                </div>
                <h1
                  className={
                    lightText ? "hero__heading" : "hero__heading hero--dark"
                  }
                >
                  {headline}
                </h1>
                <p
                  className={
                    lightTextDesc
                      ? "hero__subtitle"
                      : "hero__subtitle hero--dark"
                  }
                >
                  {description}
                </p>
              </div>
            </div>
            <div className="hero__col">
              <div className="hero__img-wrapper">
                <img
                  src={src}
                  alt={alt}
                  className={largeImage ? "hero__img--large" : "hero__img"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

HeroSection.defaultProps = {
  bottomPadding: true,
  topPadding: true,
  largeImage: false,
};

HeroSection.propTypes = {
  lightBg: PropTypes.bool,
  topLine: PropTypes.string,
  lightText: PropTypes.bool,
  lightTextDesc: PropTypes.bool,
  headline: PropTypes.string,
  description: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  imgStart: PropTypes.string,
  bottomPadding: PropTypes.bool,
  topPadding: PropTypes.bool,
  largeImage: PropTypes.bool,
};

export default HeroSection;
